import React from "react";
import { Breadcrumbs } from "@material-tailwind/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdOutlineHomeWork } from "react-icons/md";
import { GiMoneyStack } from "react-icons/gi";
import { useState, useEffect } from "react";
import Loading from "../../COMPONENTS/Loading/Loading";
import { GoArrowLeft } from "react-icons/go";
import SidebarTop from "../SidebarTop";
import { IoMdPin } from "react-icons/io";
import { MdOutlineDateRange } from "react-icons/md";
import { BiSolidCategory } from "react-icons/bi";
import { FaBuilding, FaUser } from "react-icons/fa6";
import Trans from "../../../API/tourisme/transaction/index";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

function Modifier() {
  let authUser = JSON.parse(localStorage.getItem("data") || "null");
  const [loading, setLoading] = useState(true);
  const [fourniss, setFourniss] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [service, setService] = useState([]);
  const [info,setInfo] = useState({})
  const [errors,setErrors] = useState({})
  const location = useLocation();
  const navigate = useNavigate();

  const formatDateToYYMMDD = (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;            
  };

  const id = location.state;

  const [formData, setFormData] = useState({
    nom: '',
    dateach: '',
    lieu: "",
    montant: "",
    section: "",
    category: "",
    nomc: "",
    user: authUser?.userId,
    id:id
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const getAllService = () => {
    Trans.getService()
      .then((res) => {
        if (res.data.status === 200) {
          setService(res.data.services);
        }
      })
      .catch((err) => {
        console.log("Erreur lors de la recuperation ", err);
      });
  };

  const getAllFournisseur = () => {
    Trans.getFournisseur()
      .then((res) => {
        if (res.data.status === 200) {
          setFourniss(res.data.fournisseur);
        }
      })
      .catch((err) => {
        console.log("Erreur lors de l'appel a l'API ", err);
      });
  };

  const getAllCustomer = () => {
    Trans.getCustomer()
      .then((res) => {
        if (res.data.status === 200) {
          setCustomers(res.data.customers);
        }
      })
      .catch((err) => {
        console.log("Erreur lors de l'appel a l'API ", err);
      });
  };

  const DepenseByUser = async ()=>{
       Trans.getDepenseByUser(id)
            .then((res)=>{
              if(res.data.status === 200)
              {             
                setInfo(res.data.depense)
              }
            }).catch((err)=>{
              console.log("Erreur lors de l'appel a l'API ",err)
            })
  }

  const handleSubmit = async (e)=>{
     e.preventDefault();
     Trans.UpdateTransaction(formData)
          .then((res)=>{
            if(res.data.status === 200)
            {
                toast.success(res.data.message)
                navigate("/Dashboard/Transation");
            }
            if(res.data.status === 422)
                {
                  setErrors(res.data.errors)
                  return;
                }
          }).catch((err)=>{
             console.log("Erreur lors de l'appel a l'API ",err)
          })
  }

  useEffect(()=>{
      setFormData((prev)=>({
        ...prev,
        nom: info.Descriptions,
        dateach: formatDateToYYMMDD(info.Dates),
        category:info.Types_Charges,
        montant:info.unique_price,
        section: info.Types,
        nomc: info.Providers_Numbers,
        lieu:info.Notes
      }))
  },[info])

  useEffect(() => {
    getAllService();
    getAllFournisseur();
    getAllCustomer();
    DepenseByUser()

    const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      setLoading(false);
    }, 2000); // 5000 millisecondes = 5 secondes

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, []);

  const {t} = useTranslation()

 
  

  return (
    <div className="flex flex-row bg-[#eeee]">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          {/* sidebar left */}
           <ToastContainer/>
          <div className="w-screen  barre_scroll h-screen">
            {/* navbar top orange */}
            <SidebarTop />
            {/* navbar top gris*/}
            <div className="bg-[#f7f7f7] sm:h-10 s:h-14 mt-[50px]">
              <Breadcrumbs>
                <Link to="" className="opacity-60 md:text-base s:text-xs">
                  Transation
                </Link>
                <Link
                  to="/Dashboard/Transation"
                  className="opacity-60 md:text-base s:text-xs"
                >
                  {t("Revenus & Depenses")}
                </Link>
                <Link to="" className="md:text-base s:text-xs">
                  {t("Modifier")}
                </Link>
              </Breadcrumbs>
            </div>

            <Link to="/Dashboard/Transation">
              <div className="flex flex-row items-center space-x-2 relative top-8 s:left-5 sm:left-12 w-[280px]">
                <GoArrowLeft className="text-[#fe7f2d]  text-lg" />
                <p>{t("Retour à la page précedente")}</p>
              </div>
            </Link>
            {/* container formulaire */}
            <div className="flex justify-center py-20  ">
              <form onSubmit={handleSubmit} className="flex flex-col space-y-3 items-center  ">
                <div className="bg-white  s:p-4 xs:p-10 xs:w-full s:w-[260px] sm:w-[340px]  rounded-md border-b-8  shadow flex flex-col space-y-6 ">
                  {/* Titre */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineHomeWork className="text-xl text-[#fe7f2d]" />
                      <label>{t("Titre")}</label>
                    </div>
                    <input
                      type="text"
                      name="nom"
                      placeholder="Ex : Restauration; Location de vehicule; Achat de ticket; Achat de materiel"
                      value={formData?.nom ?? ''}
                      onChange={handleChange}
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.nom && <p className="text-red-500">{errors.nom}</p> }
                  </div>
                  {/* Date */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <MdOutlineDateRange className="text-xl text-[#fe7f2d]" />
                      <label>{t("Date d'achat")}</label>
                    </div>
                    <input
                        type="date"
                        name="dateach"
                        value={formData?.dateach}
                        onChange={handleChange}
                        className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.dateach && <p className="text-red-500">{errors.dateach}</p> }
                  </div>
                  {/* Lieu */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <IoMdPin className=" text-[#fe7f2d]" />
                      <label>{t("Lieu")}</label>
                    </div>
                    <input
                      type="text"
                      name="lieu"
                      placeholder="Ex : Cocody, Abidjan, Côte d'ivoire "
                      value={formData?.lieu}
                      onChange={handleChange}
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.lieu && <p className="text-red-500">{errors.lieu}</p> }
                  </div>
                  {/* categorie*/}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <BiSolidCategory className="text-xl text-[#fe7f2d]" />
                      <label>{t("Categorie")}</label>
                    </div>
                    <select
                      onChange={handleChange}
                      name="category"
                      value={formData?.category}
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                    >
                      <option value="">{t("Choisir la categorie")}</option>
                      <option value="1">{t("Depense")}</option>
                      <option value="2">{t("Vente")}</option>
                      {/* <option>Autre</option> */}
                    </select>
                    {errors.category && <p className="text-red-500">{errors.category}</p> }
                  </div>

                  {formData.category === 1 && (
                    <div className="flex flex-col space-y-3">
                      <div className="flex flex-row items-center space-x-2">
                        <FaBuilding className="text-xl text-[#fe7f2d]" />
                        <label>{t("Fournisseur")}</label>
                      </div>
                      <div className="relative">
                        <select
                          onChange={handleChange}
                          value={formData?.nomc}
                          name="nomc"
                          className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4 pr-16"
                        >
                          <option value="">
                            {t("Veuillez choisir le fournisseur")}
                          </option>
                          {fourniss.map((four, index) => (
                            <option
                              key={index}
                              value={String(four?.Providers_Numbers)}
                            >
                              {four?.Names}
                            </option>
                          ))}
                        </select>
                        {/* <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                                              <IoIosAddCircle
                                                className="text-xl text-[#fe7f2d]"
                                                onClick={() => setOpen(!open)}
                                              />
                                            </div> */}
                      </div>
                    </div>
                  )}

                  {formData.category === 2 && (
                    <>
                      <div className="flex flex-col space-y-3">
                        <div className="flex flex-row items-center space-x-2">
                          <FaUser className="text-xl text-[#fe7f2d]" />
                          <label>{t("Client")}</label>
                        </div>

                        <div className="relative">
                          <select
                            onChange={handleChange}
                            value={formData?.nomc}
                            name="nomc"
                            className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                          >
                            <option value="">
                              {t("Veuillez choisir le client")}
                            </option>
                            {customers.map((custo, index) => (
                              <option
                                key={index}
                                value={String(custo?.Customers_Numbers)}
                              >
                                {custo?.Names + " " + custo?.LastName}
                              </option>
                            ))}
                          </select>
                          {/* <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                                              <IoIosAddCircle
                                                className="text-xl text-[#fe7f2d]"
                                                onClick={() => setOpens(!opens)}
                                              />
                                            </div> */}
                        </div>
                      </div>
                    </>
                  )}

                  {/* Montant */}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <GiMoneyStack className="text-xl text-[#fe7f2d]" />
                      <label>{t("Montant")}</label>
                    </div>
                    <input
                      type="number"
                      name="montant"
                      placeholder="Ex : 400000 "
                      value={formData?.montant}
                      onChange={handleChange}
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded"
                    />
                    {errors.montant && <p className="text-red-500">{errors.montant}</p> }
                  </div>
                  {/* Section*/}
                  <div className="flex flex-col space-y-3">
                    <div className="flex flex-row items-center space-x-2">
                      <BiSolidCategory className="text-xl text-[#fe7f2d]" />
                      <label>Section</label>
                    </div>
                     <select
                      onChange={handleChange}
                      value={formData?.section}
                      name="section"
                      className="xs:w-[500px] s:w-[230px] sm:w-[300px] h-10 rounded pl-4"
                     >
                      <option value="">{t("Choisir la categorie")}</option>
                      {service.map((ser, index) => (
                        <option key={index} value={String(ser?.Items_Numbers)}>
                          {ser?.fr_Name}
                        </option>
                      ))}
                    </select>
                    {errors.section && <p className="text-red-500">{errors.section}</p> }
                  </div>
                </div>

                <button className="bg-[#FCCA46] w-[150px] h-10 rounded text-white">
                  {t("Mettre à jour")}
                </button>
              </form>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Modifier;
